import { render, staticRenderFns } from "./TabSites.vue?vue&type=template&id=13aa743a&scoped=true&"
import script from "./TabSites.vue?vue&type=script&lang=js&"
export * from "./TabSites.vue?vue&type=script&lang=js&"
import style0 from "./TabSites.vue?vue&type=style&index=0&id=13aa743a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aa743a",
  null
  
)

export default component.exports